<template>
    <header class="header_fix">
        <nav class="navbar">
            <a class="navbar-brand mr-auto ml-0 new_logo_well" href="/">
                <img src="@/assets/images/logo.png" class="img-fluid" alt="">
            </a>
        </nav>
    </header>
</template>

<script>
/*eslint-disable */
const $ = window.jQuery = require('jquery');

import { bus } from '@/main';

export default {
    name: 'header-before-login',
    components: {},
    props: [],
    data() {
        return {
            togglePopup: false
        }
    },
    computed: {

    },
    mounted() {
    },
    methods: {
        handleScroll() {
            let header = document.querySelector(".header_fix");
            let covid_19_popup = document.querySelector(".covid_19_popup");
            if (window.scrollY > 30 && !header.className.includes('darkBg')) {
                header.classList.add('darkBg');
                if (covid_19_popup) {
                    covid_19_popup.classList.add('moved_to_top_icon');
                }
            } else if (window.scrollY < 30) {
                header.classList.remove('darkBg');
                if (covid_19_popup) {
                    covid_19_popup.classList.remove('moved_to_top_icon');
                }
            }
        },
        togglePopupFunction() {
            this.togglePopup = !this.togglePopup;
            bus.$emit('togglePopipOverlay', this.togglePopup);
        }
    },
    created() {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
    },

}

</script>

<style lang="scss" scoped>
header {
    background: rgba(0, 0, 0, 0.6);

    .navbar-brand {
        transform-origin: center center;
        -webkit-transform-origin: center center;
        position: relative;
        transform: scale(1);
        -webkit-transform: scale(1);
        -moz-transform: scale(1);
        transition: transform ease 0.5s;
        -webkit-transition: transform ease 0.5s;
        -moz-transition: transform ease 0.5s;

        &:hover {
            transform: scale(1.07);
            -webkit-transform: scale(1.07);
            -moz-transform: scale(1.07);
        }
    }
}

.header_fix.darkBg {
    background: #000 !important;
    box-shadow: 0px 0px 5px rgba(255, 247, 136, 0.1);
}
</style>